<template>
  <div>
    <v-card :loading="loading">
      <v-simple-table>
        <thead>
          <tr>
            <th>Category</th>
            <th>Type</th>
            <th>Brand</th>
            <th>Notes</th>
            <th class="text-center">Required</th>
            <th class="text-center">Available</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="equipment in site_equipment" :key="equipment.id">
            <td>{{equipment.category}}</td>
            <td>{{equipment.type}}</td>
            <td>{{equipment.brand}}</td>
            <td>{{equipment.notes}}</td>
            <td class="text-center">{{equipment.b_required | boolean}}</td>
            <td class="text-center">{{equipment.b_cme_supplier_has_available | cmeBool}}</td>
            <td><v-btn text color="primary" @click="edit(equipment)">Edit</v-btn></td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <span v-if="listNotCompleted" class="red--text caption">All equipment must have availability updated before the list can be approved</span>&nbsp;&nbsp;
        <v-btn color="primary" :disabled="listNotCompleted" @click="approveList" v-if="site_equipment">Approve this Equipment List</v-btn>
      </v-card-actions>
    </v-card>
    <EqiupmentTableDialog @saveinfo="saveInfo" @closedialog="closeDialog" :item="item" :dialog="dialog" :loading_dialog="loading_dialog"/>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'
import EqiupmentTableDialog from './EqiupmentTableDialog'

export default {
  props: {
    site_equipment: Array,
    loading: Boolean
  },
  components: {
    EqiupmentTableDialog
  },
  data() {
    return {
      loading_dialog: false,
      dialog: false,
      item: null
    }
  },
  filters: {
    boolean: function(boolean) {
      return boolean ? 'Yes' : 'No'
    },
    cmeBool: function(value) {
      if(value == 1) { return 'Yes' }
      else if(value == 0) { return 'No' }
      else { return '-' }
    }
  },
  computed: {
    listNotCompleted() {
      if(this.site_equipment == null) return
      const vm = this
      var flags = [], output = [], l = vm.site_equipment.length, i;
      for( i=0; i<l; i++) {
        if( flags[vm.site_equipment[i].b_cme_supplier_has_available]) continue
        flags[vm.site_equipment[i].b_cme_supplier_has_available] = true
        output.push(vm.site_equipment[i].b_cme_supplier_has_available)
      }
      return output.includes(2)
    }
  },
  methods: {
    approveList() {
      const vm = this
      const id = vm.$store.state.assignment
      const putOpusApi = firebase.functions().httpsCallable('putOpusApi')

      putOpusApi({
        table: 'vendor_assignments',
        params: {
          id: id,
          B_Equipment_Approved: true
        }
      }).then(function() {
        // console.log(res)
      })
    },
    closeDialog() {
      this.dialog = false
    },
    edit(item) {
      this.item = item
      this.dialog = true
    },
    saveInfo(data) {
      const vm = this
      const putOpusApi = firebase.functions().httpsCallable('putOpusApi')

      vm.loading_dialog = true
      putOpusApi({
        table: 'performance_site_equipments',
        params: {
          id: data.id,
          Category: data.category,
          Type: data.type,
          Brand: data.brand,
          Notes: data.notes,
          B_CME_Supplier_Has_Available: data.b_cme_supplier_has_available
        }
      }).then(function() {
        vm.dialog = false
        vm.loading_dialog = false
        vm.$emit('reloadtable')
      })
    }
  }
}
</script>